<snelstart-ui-button type="secondary"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(2)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(2)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     (click)="this.showDialog()">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition id="lg" title="Specificatie overige materi&euml;le vaste activa" size="lg" [(visible)]="dialogVisible">
    <snelstart-ui-dialog-header-content>
        Vul onderstaand de waardes is voor de balanspost(en) per einde van het boekjaar.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
        <form [formGroup]="formGroup" (change)="saveForm()">
            <div>
                <snelstart-ui-number-form-control formControlName="aanschafWaarde"
                                                  label="Aanschafwaarde"
                                                  class="custom-input-250"
                                                  [decimals]="0"
                                                  prefix="€"
                                                  align="right"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div>
                <snelstart-ui-number-form-control formControlName="restWaarde"
                                                  label="Restwaarde"
                                                  class="custom-input-250"
                                                  [decimals]="0"
                                                  prefix="€"
                                                  align="right"
                >
                </snelstart-ui-number-form-control>
            </div>
        </form>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x>Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary" [disabled]="formGroup.invalid">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
